import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import Clickable from '../Clickable/Clickable';
import { ClickableAction } from '../Clickable/consts';
import Icon from '../Icon/Icon';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import RichText from '../RichText/RichText';
import styles from './BenefitsDealCard.module.scss';
import { OVERLAY_ICONS, OVERLAY_TEXTS } from './consts';
import type { BenefitsDealCardProps } from './types';

const BenefitsDealCard = ({
  logo,
  image,
  headline,
  link,
  variant,
  badgeText,
}: BenefitsDealCardProps) => {
  const shouldShowBadge = !variant && badgeText;

  const clickContext =
    [badgeText, variant && OVERLAY_TEXTS[variant]]
      .filter(Boolean)
      .join(' - ') || 'Nicht verfügbar';

  return (
    <Clickable
      actionType={ClickableAction.Linkintern}
      linkintern={link}
      customDataLayer={{
        clickContext,
        customClickText: headline,
        customClickElementType: 'BenefitsDealCard',
      }}
    >
      <div className={styles.base}>
        {variant && (
          <div className={styles.overlay}>
            <Icon
              variant={OVERLAY_ICONS[variant]}
              size="iconSize64"
              isOutlined
            />
            <span className={styles.overlayText}>{OVERLAY_TEXTS[variant]}</span>
          </div>
        )}
        <LegacyPicture className={styles.logo} asset={logo} />
        <div className={styles.imageWrapper}>
          {shouldShowBadge && (
            <div className={styles.badge}>
              <span className={styles.badgeText}>{badgeText}</span>
            </div>
          )}
          <LegacyPicture
            className={styles.image}
            asset={image}
            fitCover
            defaultWidth={320}
            breakpointAspectRatioConfigs={[
              {
                breakpoint: BreakPoint.XSS,
                width: 375,
              },
              {
                breakpoint: BreakPoint.SM,
                width: 418,
              },
              {
                breakpoint: BreakPoint.MD,
                width: 350,
              },
              {
                breakpoint: BreakPoint.LG,
                width: 370,
              },
              {
                breakpoint: BreakPoint.XL,
                width: 305,
              },
            ]}
          />
        </div>
        <div className={styles.titleWrapper}>
          <RichText className={styles.title}>{headline}</RichText>
        </div>
      </div>
    </Clickable>
  );
};

export default BenefitsDealCard;
